import { PageIntro } from "./PageIntro";
import { ExternalLink } from "./ExternalLink";
import { TransportSchedule } from "./TransportSchedule";

const railwayStop = "https://maps.app.goo.gl/NEhkueSmgsK7hhZcA";
const transferStop = "https://maps.app.goo.gl/fbkyBTNgYXkxS5N7A";

export function TimetablePage({
  mobileTable = false,
}: {
  mobileTable?: boolean;
}) {
  return (
    <div className="standard-page timetable-page">
      <PageIntro eyebrow="BUS SCHEDULE" title="公車時刻表" en="TIMETABLE">
        <p>
          從台東市區到下都蘭，再一路延伸至東海岸主要景點，班次與沿途時間一次看懂。點擊車號可查看即時動態。
        </p>
      </PageIntro>
      <section
        className="timetable-origin-guide"
        aria-labelledby="origin-guide-title"
      >
        <div>
          <p className="eyebrow">WHERE TO BOARD</p>
          <h2 id="origin-guide-title">選擇上車地點</h2>
        </div>
        <div className="bus-origin-list">
          <section>
            <h3>台東轉運站</h3>
            <p>班次選擇較多；部分班次不會停靠台東火車站。</p>
            <ExternalLink className="text-link" href={transferStop}>
              查看站牌位置 ↗
            </ExternalLink>
          </section>
          <section>
            <h3>台東火車站</h3>
            <p>出站後前往客運月台，並確認欲搭班次有停靠火車站。</p>
            <ExternalLink className="text-link" href={railwayStop}>
              查看站牌位置 ↗
            </ExternalLink>
          </section>
        </div>
      </section>
      <TransportSchedule mobileTable={mobileTable} />
      <div className="timetable-back">
        <a className="text-link" href="/direction">
          ← 回到交通方式
        </a>
      </div>
    </div>
  );
}
